import React, { useState } from 'react'
import type { PageQuery } from 'apollo-gql'
import { useTranslation } from 'lib/i18n'

import CtaButton from 'components/CtaButton/CtaButton'
import DisplayHeading from 'components/DisplayHeading/DisplayHeading'
import HeaderHero from 'components/HeaderHero/HeaderHero'
import { IconTimesCircle } from 'components/UI/Icons'

import styles from './CmsPageHeaderContent.module.css'

type CmsPageHeaderContentProps = {
  pageHeader: PageQuery['market']['page']['cmsItemPageHeader']
}

const CmsPageHeaderContent: React.FC<CmsPageHeaderContentProps> = ({
  pageHeader,
}) => {
  const { t } = useTranslation()
  const [showVideo, setShowVideo] = useState(false)
  const { title, video = false, tagline = '', buttonText = '' } = pageHeader

  return (
    <>
      <HeaderHero>
        <DisplayHeading>{title}</DisplayHeading>
        <p className={styles.cmsPageHeaderTagline}>{tagline}</p>
        {video && (
          <CtaButton
            onClick={() => {
              setShowVideo(true)
            }}
            style={{ marginTop: 20 }}
          >
            {buttonText}
          </CtaButton>
        )}
      </HeaderHero>
      {showVideo && (
        <div
          className={styles.videoOverlay}
          onClick={(event) => {
            if (event.target === event.currentTarget) setShowVideo(false)
          }}
          role="button"
          tabIndex={0}
        >
          <div className={styles.videoWrapper}>
            <button
              className={styles.closeButton}
              onClick={() => {
                setShowVideo(false)
              }}
              type="button"
            >
              <IconTimesCircle color="#fff" />
              {t('CmsPageHeaderContent.closeButton', 'Close')}
            </button>
            <iframe
              width="560"
              height="315"
              src={`https://www.youtube.com/embed/${video}`}
              title="YouTube"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </>
  )
}

export default CmsPageHeaderContent
